// Access to the reporting pages (/sales, /management, /metrics) used to be decided
// by a copy of this email list inline in each component. The copies had drifted:
// /sales allowed operations@storemax.com.au while /management and /metrics allowed
// operations@storemax.com, so the same person could open one page and get a blank
// screen on the other. One list, checked from one place, is what stops that
// happening again.
//
// Both the singular and plural operations spellings are listed because either may
// be a live account - the address actually in use is the singular operation@.
export const REPORTING_EMAILS = [
  'sunil@storemax.com.au',
  'gary@storemax.com',
  'wahabtariq55@gmail.com',
  'operation@storemax.com.au',
  'operations@storemax.com.au',
  'operations@storemax.com',
];

// Parse.User.current() is null when nobody is logged in, and stored addresses are
// not reliably lower-cased, so normalise before comparing rather than trusting the
// raw field.
const emailOf = (user) => (user?.get?.('email') || '').trim().toLowerCase();

export const hasReportingAccess = (user) => REPORTING_EMAILS.includes(emailOf(user));

// Operations accounts get their own quotation status workflow. This matches on the
// start of the local part instead of the full address so that operation@ and
// operations@ land on the same side of the check - the previous test looked for the
// substring 'operations', which silently excluded the singular address and handed
// that user the sales workflow instead.
export const isOperationsUser = (user) => /^operation/.test(emailOf(user));

// Deleting a quotation is limited to operations plus the one named admin account.
export const canDeleteQuotations = (user) =>
  isOperationsUser(user) || emailOf(user) === 'sunil@storemax.com.au';
